import * as types from './user-mutation-types';

export default {
  [types.SET_USER_DATA](state, payload) {
    state.userData = payload;
  },
  [types.SET_PEER_DATA](state, payload) {
    state.peerData = payload;
  },
  [types.SET_USER_INFO](state, userInfo) {
    state.userInfo = userInfo;
  },
  [types.SET_IP_ADDRESS](state, ipAddress) {
    state.ipAddress = ipAddress;
  },
  [types.SET_CS_DATA](state, peerCSData) {
    state.peerCSData = peerCSData;
  },
  [types.SET_BD_DATA](state, peerBdData) {
    state.peerBdData = peerBdData;
  },
  [types.SET_AUDIT_DATA](state, publicAuditData) {
    state.publicAuditData = publicAuditData;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user/user-mutations.js